import { useComputedColorScheme, Paper } from '@mantine/core';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import React from 'react';

export const LoadingPage: React.FC = () => {
  const computedColorScheme = useComputedColorScheme('dark');
  return (
    <Paper
      data-testid="loading-page"
      style={{
        backgroundImage: `url(/background-${computedColorScheme}.svg)`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backdropFilter: 'blur(30px)',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <DotLottieReact
        src={'/BluePulseSlower.json'}
        autoplay={true}
        loop={true}
        style={{ width: 700, height: 700 }}
        data-testid="loading-animation"
      />
    </Paper>
  );
};
